function Lightbox({ lightbox, onClose, onNavigate, onCopy }) {
    if (!lightbox?.isOpen) return null;

    return (
        <div className="lightbox" onClick={onClose}>
            <div className="lightbox__content" onClick={(event) => event.stopPropagation()}>
                <button type="button" className="lightbox__close" onClick={onClose}>
                    ×
                </button>
                {lightbox.mode === 'image' ? (
                    <>
                        {lightbox.images.length > 1 && (
                            <>
                                <button
                                    type="button"
                                    className="lightbox__nav lightbox__nav--prev"
                                    onClick={() => onNavigate(-1)}
                                >
                                    ‹
                                </button>
                                <button
                                    type="button"
                                    className="lightbox__nav lightbox__nav--next"
                                    onClick={() => onNavigate(1)}
                                >
                                    ›
                                </button>
                            </>
                        )}
                        <img
                            src={lightbox.images[lightbox.index]}
                            alt="preview"
                            className="lightbox__image"
                        />
                        {lightbox.images.length > 1 && (
                            <div className="lightbox__counter">
                                {lightbox.index + 1} / {lightbox.images.length}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="lightbox__text">
                        <button
                            type="button"
                            className="ghost"
                            onClick={() => onCopy(lightbox.text, 'Текст')}
                        >
                            Скопировать
                        </button>
                        <pre>{lightbox.text}</pre>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Lightbox;
